import { render, staticRenderFns } from "./DeployDashboard.vue?vue&type=template&id=2f2c1374&scoped=true&"
import script from "./DeployDashboard.vue?vue&type=script&lang=js&"
export * from "./DeployDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DeployDashboard.vue?vue&type=style&index=0&id=2f2c1374&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2c1374",
  null
  
)

export default component.exports